module.exports = __webpack_public_path__ + "img/contact-magnusjonsing.8503b20d.png";